// src/features/dashboard/components/ManagerDashboard/ProductivityReport/ProductivityHeader.tsx

interface Props {
  averageProductivity?: number;
  totalTeamLeads?: number;
  totalAssociates?: number;
}

const ProductivityHeader = ({
  averageProductivity = 0,
  totalTeamLeads = 0,
  totalAssociates = 0,
}: Props) => {

  const employeeName =
    localStorage.getItem('employeeName') || '';

  const employeeCode =
    localStorage.getItem('employeeCode') || '';

  const formattedDate =
    new Date().toLocaleDateString(
      'en-GB',
      {
        day: '2-digit',
        month: 'short',
      },
    );

  return (

    <div
      className="
        mb-5
        w-full

        [@media(max-width:1100px)]:mb-3
        [@media(max-width:1000px)]:mb-2.5
      "
    >

      <div
        className="
          flex
          w-full
          min-w-0
          items-center
          gap-3

          [@media(max-width:1100px)]:gap-2

          [@media(max-width:1000px)]:gap-1.5
        "
      >

        {/* =========================================================
            TITLE
        ========================================================== */}

        <h2
          className="
            min-w-0
            shrink-0

            whitespace-nowrap

            text-[16px]
            font-bold
            leading-5

            text-[#003E7E]

            [@media(max-width:1100px)]:text-[13px]
            [@media(max-width:1100px)]:leading-4

            [@media(max-width:1000px)]:text-[11px]
            [@media(max-width:1000px)]:leading-3
          "
        >
          Avg. Productivity ·{' '}
          {averageProductivity.toFixed(2)}%
        </h2>


        {/* =========================================================
            INFORMATION BADGE
        ========================================================== */}

        <span
          className="
            min-w-0
            max-w-full
            overflow-hidden

            rounded-full

            bg-blue-50

            px-4
            py-2

            text-[12px]
            leading-4

            text-blue-600

            truncate

            [@media(max-width:1100px)]:px-3
            [@media(max-width:1100px)]:py-1.5
            [@media(max-width:1100px)]:text-[10px]
            [@media(max-width:1100px)]:leading-3

            [@media(max-width:1000px)]:px-2.5
            [@media(max-width:1000px)]:py-1
            [@media(max-width:1000px)]:text-[8px]
            [@media(max-width:1000px)]:leading-3
          "
          title={`
            ${employeeName} (${employeeCode}) ·
            ${totalTeamLeads} Teams ·
            ${totalAssociates} Associates ·
            WTD ${formattedDate}
          `}
        >
          {employeeName} ({employeeCode}) ·{' '}
          {totalTeamLeads} Teams ·{' '}
          {totalAssociates} Associates · WTD{' '}
          {formattedDate}
        </span>

      </div>

    </div>
  );
};

export default ProductivityHeader;